import { render, staticRenderFns } from "./LabEquipmentView.vue?vue&type=template&id=49980f33&scoped=true"
import script from "./LabEquipmentView.vue?vue&type=script&lang=js"
export * from "./LabEquipmentView.vue?vue&type=script&lang=js"
import style0 from "./LabEquipmentView.vue?vue&type=style&index=0&id=49980f33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49980f33",
  null
  
)

export default component.exports